/** The input box of a setting (`box`: without a width, for inputs of their own width). */
const box = "h-6 rounded-md border border-line bg-surface-2 px-1.5 text-[12px] disabled:opacity-60";
export const inputBox = `${box} w-full min-w-0`;
